import React, {useEffect} from 'react';
import {mostrarCompaniaDatosSinoEsta, mostrarCompanias} from "../redux/reducers/companiasReducers";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {confCamposVals, IConfCampos} from "../redux/types/ICompania";

export function useCustomFormInput(prefix="cliente") {
    const generales = useAppSelector(state => state.companias)
    const dispatch = useAppDispatch();
    const [confCampos, setConfCampos] = React.useState<IConfCampos>();

    useEffect(()=>{
        dispatch(mostrarCompaniaDatosSinoEsta());
    },[dispatch])
    useEffect(()=>{
        let items = {...generales?.data?.confCampos};

        if(items){
            Object.keys(items).forEach(key=>{
                if(key.indexOf(prefix) !== 0 || (items as any)[key] == null){
                    delete (items as any)[key];
                }
            })
        }
        setConfCampos(items);

    },[generales,prefix])

    return confCampos;
}


